import { ChakraText, EquipUITheme } from '@equip.health/ui';
import { isNil } from 'lodash';

import { TaskStatusLabel } from '~/lib/util/task.util';

const { label: labelStyle } = EquipUITheme.typography;

interface DueStatusProps {
  daysFromNow: number;
  dueDate: string;
  statusLabel: TaskStatusLabel;
}

type StatusDisplayProps = {
  bold?: boolean;
  color?: string;
  fontWeight?: string;
  text: string;
};

const StatusDisplay = ({
  bold = false,
  color = 'neutral.secondary',
  text,
}: StatusDisplayProps) => (
  <ChakraText
    {...labelStyle}
    color={color}
    fontWeight={bold ? '700' : labelStyle.fontWeight}
    lineHeight="16.8px"
  >
    {text}
  </ChakraText>
);

const DueStatus = ({ daysFromNow, dueDate, statusLabel }: DueStatusProps) => {
  if (
    isNil(daysFromNow) ||
    isNil(dueDate) ||
    [
      TaskStatusLabel.DONE,
      TaskStatusLabel.VOID,
      TaskStatusLabel.CLOSED,
    ].includes(statusLabel)
  ) {
    return null;
  }

  if (daysFromNow > 0) {
    return (
      <StatusDisplay
        text={`In ${daysFromNow} day${daysFromNow > 1 ? 's' : ''}`}
      />
    );
  }

  if (daysFromNow === 0) {
    return <StatusDisplay bold color="tertiary.marigold.base" text="Today" />;
  }

  return <StatusDisplay bold color="critical.base" text={dueDate} />;
};

export default DueStatus;
